export var AvailabilityStates;
(function (AvailabilityStates) {
    AvailabilityStates["AvailableSoon"] = "AvailableSoon";
    AvailabilityStates["OnStock"] = "OnStock";
    AvailabilityStates["TemporaryOutOfStock"] = "TemporaryOutOfStock";
    AvailabilityStates["OutOfStock"] = "OutOfStock";
    AvailabilityStates["Historic"] = "Historic";
    AvailabilityStates["PreOrder"] = "PreOrder";
})(AvailabilityStates || (AvailabilityStates = {}));
//# sourceMappingURL=types.js.map